// import Head from 'next/head';
import { Box, Container, Grid, Typography } from '@mui/material';
import Account from './Account/Account';

import { AccountDetails } from './Account/AccountDetails';


const RiderAccount = () => (
  <>
    {/* <Head>
      <title>
        Account
      </title>
    </Head> */}
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 8
      }}
    >
      <Container maxWidth="lg">
        <Typography
          sx={{ mb: 3 }}
          variant="h4"   fontWeight="bold"
        >
          Account
        </Typography>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            lg={4}
            md={6}
            xs={12}
          >
            <Account />
          </Grid>
          <Grid
            item
            lg={8}
            md={6}
            xs={12}
          >
            <AccountDetails />
          </Grid>
        </Grid>
      </Container>
    </Box>
  </>
);



export default RiderAccount;
